import React, {useState} from 'react';

function Radio({showClass, chosenColor}) {

    let [color, setColor] = useState('red');
    
    //choose color and callback that colot
    const colorPicker = (color) => {
        let active = color.toString();
        setColor(active);
        chosenColor(active);
    }

    return (
        <div id="color-picker" className={showClass ? "" : "hide"}>
        <div 
        className={color === 'red' ? "circle active": "circle"} id="red" onClick={() => colorPicker('red')}></div>
        <div 
        className={color === 'blue' ? "circle active": "circle"} id="blue" onClick={() => colorPicker('blue')}></div>
        <div 
        className={color === 'green' ? "circle active": "circle"} id="green" onClick={() => colorPicker('green')}></div>
    </div>
    )
}

export default Radio;